// Срок жизни куки с токеном.
//
// vue-cookies по умолчанию ставит сутки, поэтому оператора выбрасывало из
// системы каждый день, хотя сам токен ещё действовал: на бэкенде JWT живёт
// 30 дней (JsonWebToken::DEFAULT_EXPIRATION), столько же живёт запись сессии
// (LoginSession::LIFETIME). Кука должна жить ровно столько же — иначе выход
// происходит не по правилу, а по умолчанию библиотеки.
export const TOKEN_COOKIE_EXPIRES = '30d'
